var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoUmbra(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150.454,
    height: 58.358,
    viewBox: "0 0 150.454 58.358",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_648",
    "data-name": "Rectangle 648",
    className: "cls-1",
    width: 150.454,
    height: 58.358
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1106",
    "data-name": "Group 1106",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1105",
    "data-name": "Group 1105",
    className: "cls-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M0,14.24V.125H4.309v13.94c0,4.552,2.345,6.969,6.2,6.969,3.817,0,6.165-2.276,6.165-6.794V.125h4.306v13.9c0,7.319-4.131,11-10.541,11C4.063,25.026,0,21.349,0,14.24",
    transform: "translate(0 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M22.443.125H27.03l7.459,11.592L41.949.125h4.589V24.641H42.229V7.061l-7.74,11.555H34.35L26.68,7.131v17.51H22.443Z",
    transform: "translate(8.946 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M47.687.125h11A8.858,8.858,0,0,1,65.093,2.3a5.493,5.493,0,0,1,1.646,4.062V6.43a5.837,5.837,0,0,1-3.5,5.463c2.873.98,4.87,2.627,4.87,5.954v.07c0,4.378-3.608,6.724-9.071,6.724H47.687ZM62.43,7.061c0-1.926-1.54-3.117-4.308-3.117h-6.2v6.513h5.883c2.768,0,4.622-1.085,4.622-3.326ZM58.753,14.1H51.925v6.724h7.143c2.943,0,4.729-1.157,4.729-3.362v-.07c0-2.067-1.646-3.292-5.043-3.292",
    transform: "translate(19.008 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M69.274.125H80.2a9.881,9.881,0,0,1,7.076,2.453,7.4,7.4,0,0,1,2.031,5.288v.07c0,4.027-2.415,6.443-5.814,7.424l6.62,9.281H85L78.975,16.1H73.582v8.545H69.274ZM79.885,12.277c3.083,0,5.043-1.61,5.043-4.1V8.11c0-2.627-1.891-4.062-5.077-4.062h-6.27v8.229Z",
    transform: "translate(27.613 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M100.082,0h3.992l10.789,24.691h-4.555l-2.487-5.919H96.229l-2.52,5.919H89.3Zm6.164,14.955-4.238-9.807-4.2,9.807Z",
    transform: "translate(35.593 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M0,43.93l1.147-.947a7.632,7.632,0,0,0,6.245,3.21c2.694,0,4.957-1.806,4.957-4.441V41.7c0-2.808-2.635-4.355-6.245-4.355H5.014l-.372-.831,6.9-7.965H1.032v-1.4h12.55V28.2L6.79,35.964c3.811.229,7.106,2.006,7.106,5.674V41.7c0,3.5-3.067,5.845-6.533,5.845A9.025,9.025,0,0,1,0,43.93",
    transform: "translate(0 10.818)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M13.1,27.14H19.78c6.3,0,10.657,4.327,10.657,9.971v.057c0,5.643-4.354,10.028-10.657,10.028H13.1Zm1.49,1.375V45.821H19.78c5.586,0,9.11-3.811,9.11-8.6v-.057c0-4.757-3.524-8.653-9.11-8.653Z",
    transform: "translate(5.223 10.818)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M31.258,44.355l.975-1.117a9.731,9.731,0,0,0,7.19,2.98c3.008,0,5.071-1.691,5.071-3.982v-.057c0-2.122-1.117-3.352-5.674-4.27-4.811-.973-6.761-2.607-6.761-5.645v-.057c0-2.979,2.722-5.271,6.446-5.271a10,10,0,0,1,6.877,2.435l-.945,1.175a8.637,8.637,0,0,0-5.989-2.263c-2.95,0-4.9,1.691-4.9,3.782v.057c0,2.12,1.09,3.41,5.846,4.383,4.642.945,6.59,2.607,6.59,5.53v.057c0,3.238-2.78,5.473-6.648,5.473a11.416,11.416,0,0,1-8.08-3.21",
    transform: "translate(12.459 10.736)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M50.535,28.515H43.543V27.14H59.014v1.375h-6.99V47.2h-1.49Z",
    transform: "translate(17.356 10.818)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M57.2,38.859V27.14h1.49V38.715c0,4.729,2.55,7.449,6.79,7.449,4.069,0,6.676-2.463,6.676-7.3V27.14h1.491V38.687c0,5.758-3.352,8.824-8.224,8.824-4.814,0-8.222-3.038-8.222-8.652",
    transform: "translate(22.801 10.818)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M72.582,27.14h6.676c6.3,0,10.657,4.327,10.657,9.971v.057c0,5.643-4.354,10.028-10.657,10.028H72.582Zm1.49,1.375V45.821h5.186c5.586,0,9.11-3.811,9.11-8.6v-.057c0-4.757-3.524-8.653-9.11-8.653Z",
    transform: "translate(28.931 10.818)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_646",
    "data-name": "Rectangle 646",
    width: 1.49,
    height: 20.056,
    transform: "translate(123.817 37.958)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M93.041,37.323v-.057a10.089,10.089,0,1,1,20.171-.057v.057a10.089,10.089,0,1,1-20.171.057m18.624,0v-.057c0-4.957-3.61-9.025-8.566-9.025s-8.509,4.011-8.509,8.968v.057c0,4.957,3.61,9.025,8.566,9.025s8.509-4.011,8.509-8.968",
    transform: "translate(37.086 10.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_647",
    "data-name": "Rectangle 647",
    width: 2.393,
    height: 2.393,
    transform: "translate(38.161 55.603)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoUmbra);
export default __webpack_public_path__ + "static/media/logoUmbra.9b2f38bd17c0373ae661d60b4b5329ee.svg";
export { ForwardRef as ReactComponent };